import { TextField } from '@mui/material'
import { Path, UseFormReturn } from 'react-hook-form'

type CustomTextFieldProps<T extends { [key: string]: any }> = {
  formControl: UseFormReturn<T, any, undefined>
  fieldName: Path<T>
  label: string
  required?: boolean
  disabled?: boolean
}

const CustomTextField = <T extends { [key: string]: any }>(props: CustomTextFieldProps<T>) => {
  const { formControl, fieldName, label, required = false, disabled = false } = props

  return (
    <TextField
      {...formControl.register(fieldName)}
      onChange={(e) => {
        const newValue = e.target.value as T[Path<T>]
        formControl.setValue(fieldName, newValue)
        formControl.trigger(fieldName)
      }}
      error={!!formControl.formState.errors[fieldName]}
      helperText={
        formControl.formState.errors[fieldName]?.message
          ? String(formControl.formState.errors[fieldName]?.message)
          : null
      }
      required={required}
      label={label}
      variant="outlined"
      size="small"
      disabled={disabled}
    />
  )
}

export default CustomTextField
